import React, { useEffect, useRef, useState } from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CancelIcon from "@mui/icons-material/Cancel";
import { Box } from "@mui/material";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "&": {
        backgroundColor: "rgba(0,0,0,.74)",
    },
    "& .MuiDialogContent-root": {
        minWidth: "150px",
        overflowX: "hidden",
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
    "& .MuiPaper-elevation": {
        maxWidth: "100%",
        display: "block",
        backgroundColor: "rgba(0,0,0,0)",
    },
    "& .MuiButtonBase-root": {
        right: "17px",
        top: "17px",
        cursor: "pointer",
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle
            sx={
                other.fixedTitle
                    ? {
                          m: 0,
                          p: 2,
                          position: "fixed",
                          width: "100%",
                          zIndex: "10",
                          background: "black",
                          maxWidth: "100%",
                      }
                    : { m: 0, p: 2 }
            }
            {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 17,
                        top: 17,
                        color: (theme) => theme.palette.grey[50],
                    }}>
                    <CancelIcon sx={{ fontSize: 40 }} />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

const Modal = (props) => {
    const { onClose, removeTabIndex, fullScreen, open, ...other } = props;

    useEffect(() => {
        if (open === true && removeTabIndex) {
            setTimeout(() => {
                let red = document.querySelector(".MuiDialog-container");
                if (red) {
                    red.removeAttribute("tabindex");
                }
            }, 100);
        }
    }, [open, removeTabIndex]);

    return (
        <div>
            <BootstrapDialog
                onClose={onClose}
                aria-labelledby="customized-dialog-title"
                open={open}
                {...props}
                title={props.textTitle}
                tabIndex={false}
                fullScreen={fullScreen}
                sx={{
                    bgcolor: "rgba(0,0,0,0)",
                }}>
                {!props.hideTitle && (
                    <BootstrapDialogTitle id="customized-dialog-title" onClose={props.onClose} {...other}>
                        {other.header ? other.header : props.title}
                    </BootstrapDialogTitle>
                )}
                <DialogContent sx={{ minWidth: false, overflowX: "hidden", p: "0px" }}>
                    <Box>
                        {props.hideTitle ? (
                            <a
                                style={{ cursor: "pointer", zIndex: "1", marginTop: { xs: "10px", md: "0px" } }}
                                onClick={props.onClose}
                                className="cms-hm-close-link w-inline-block">
                                <div className="cms-hm-close-criss"></div>
                                <div className="cms-hm-close-criss cross"></div>
                            </a>
                        ) : null}
                    </Box>
                    {props.children}
                </DialogContent>
                {props.hideActions ? (
                    ""
                ) : (
                    <DialogActions>
                        {other.actions ? (
                            other.actions
                        ) : (
                            <>
                                <Button onClick={props.onClose}>Cancel</Button>
                                <Button onClick={props.onSave}>Save</Button>
                            </>
                        )}
                    </DialogActions>
                )}
            </BootstrapDialog>
        </div>
    );
};

export { Modal };
